<template>
  <div class="bg-blue-50 w-full py-16 px-4 overflow-hidden">
    <div
      class="mx-auto max-w-5xl flex flex-col md:flex-row items-center gap-8 lg:gap-12"
    >
      <!-- Left side: text content -->
      <div class="flex-1 min-w-0">
        <h2 class="text-3xl lg:text-4xl font-extrabold text-primary mb-4">
          {{ content.heading }}
        </h2>
        <p class="text-gray-700 text-base lg:text-lg mb-6">
          {{ content.description }}
        </p>
        <p class="text-sm text-gray-500 mb-8">
          {{ content.statText }}
        </p>
        <JoszakiButton
          v-if="content.ctaButtonText"
          type="info"
          size="lg"
          expanded
          :to="
            content.ctaButtonUrl ||
            localePath({ name: 'requestForTenderTab', params: { activeTab: 1 } })
          "
        >
          {{ content.ctaButtonText }}
        </JoszakiButton>
      </div>

      <!-- Right side: image or placeholder -->
      <div class="flex-shrink-0 md:-my-16">
        <img
          v-if="content.imageUrl"
          v-lazy-load :data-src="content.imageUrl"
          :alt="content.heading"
          class="w-56 h-56 lg:w-72 lg:h-72 rounded-full object-cover"
        />
        <div
          v-else
          class="w-56 h-56 lg:w-72 lg:h-72 bg-primary/30 rounded-full flex items-center justify-center"
        >
          <span class="text-primary text-sm font-semibold">Image</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, useContext } from "@nuxtjs/composition-api";
import useModuleContent from "~/composables/useModuleContent";

export default {
  name: "CtaBannerModule",
  props: {
    moduleConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { $posthog } = useContext();
    const { content } = useModuleContent(props);

    onMounted(() => {
      $posthog?.capture("front_page_module_viewed", {
        module_slug: props.moduleConfig.slug,
        module_position: props.moduleConfig.position,
        module_row: props.moduleConfig.row,
        version_id: props.moduleConfig.versionId,
      });
    });

    return { content };
  },
};
</script>
